module.exports = __webpack_public_path__ + "static/media/October_2026_4.1adf78ed.webp";